import React from "react";
import { t } from "ttag";

import type { VisualizationProps } from "metabase-types/types/Visualization";

import Icon from "metabase/components/Icon";
import Ellipsified from "metabase/core/components/Ellipsified";
import { StyledButton, StyledButtonContent } from "./ActionButton.styled";

interface ActionButtonViewProps extends Pick<VisualizationProps, "settings"> {
  disabled?: boolean;
  icon?: string;
  tooltip?: string;
  isFullHeight?: boolean;
  onClick?: () => void;
  focus?: boolean;
}

function ActionButtonView({
  settings,
  disabled,
  icon,
  tooltip,
  isFullHeight,
  onClick,
  focus,
}: ActionButtonViewProps) {
  const label = settings["button.label"];
  const variant = settings["button.variant"] ?? "primary";

  const variantProps: any = {};
  if (variant !== "default") {
    variantProps[variant] = true;
  }

  return (
    <StyledButton
      disabled={!!disabled}
      onClick={onClick}
      isFullHeight={isFullHeight}
      focus={focus}
      {...variantProps}
    >
      <StyledButtonContent>
        {icon && <Icon name={icon} tooltip={tooltip} />}
        <Ellipsified>{label ?? t`Click me`}</Ellipsified>
      </StyledButtonContent>
    </StyledButton>
  );
}

export default ActionButtonView;
